'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var svgXIcon = function svgXIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '10',
      height: '10',
      viewBox: '0 0 10 10'
    }, props),
    _react2.default.createElement('path', {
      fill: '#757575',
      d: 'M10 1.1L8.9 0 5 3.9 1.1 0 0 1.1 3.9 5 0 8.9 1.1 10 5 6.1 8.9 10 10 8.9 6.1 5z'
    })
  );
};

var VstModal = function (_Component) {
  _inherits(VstModal, _Component);

  function VstModal() {
    _classCallCheck(this, VstModal);

    var _this = _possibleConstructorReturn(this, (VstModal.__proto__ || Object.getPrototypeOf(VstModal)).call(this));

    _this.state = {
      modalWidth: '',
      modalHeight: ''
    };
    _this._hideModal = _this._hideModal.bind(_this);
    return _this;
  }

  _createClass(VstModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.getElementById('root').setAttribute('aria-hidden', 'true');
      document.getElementById('content-right').style.overflow = 'hidden';
      this._modalScrollValues();
      window.addEventListener('resize', this._modalScrollValues);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      setTimeout(this._modalScrollValues, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementById('root').setAttribute('aria-hidden', 'false');
      document.getElementById('content-right').style.overflow = 'auto';
    }
  }, {
    key: '_modalScrollValues',
    value: function _modalScrollValues() {
      var rootWidth = document.getElementById('root').offsetWidth;
      var maxDocWidth = document.getElementsByClassName('vst-modalOverlay')[0].clientWidth * 0.9 - 60;
      var modalInnerWidth = Math.min(maxDocWidth, document.getElementById('modal-document-inner').offsetWidth);
      var maxDocHeight = document.getElementsByClassName('vst-modalOverlay')[0].clientHeight * 0.9 - 60;
      var modalInnerHeight = Math.min(maxDocHeight, document.getElementById('modal-document-inner').offsetHeight);
      if (rootWidth >= 500) {
        this.setState({ modalWidth: modalInnerWidth, modalHeight: modalInnerHeight });
      } else {
        this.setState({ modalWidth: modalInnerWidth, modalHeight: modalInnerHeight });
      }
    }
  }, {
    key: '_showModal',
    value: function _showModal() {
      // attach a listener to redirect the tab to the modal window if the user somehow gets out of the modal window
      /* jQuery('body').on('focusin','#mainPage',function() {
          this._setFocusToFirstItemInModal(jQuery('#modal'));
      }) */
      // save current focus
      // focusedElementBeforeModal = jQuery(':focus');
      // this._setFocusToFirstItemInModal(obj);
    }
  }, {
    key: '_hideModal',
    value: function _hideModal(e, obj) {
      // remove the listener which redirects tab keys in the main content area to the modal
      // jQuery('body').off('focusin','#mainPage');
      // set focus back to element that had it before the modal was opened
      // focusedElementBeforeModal.focus();
      if (this.props.hideModal) {
        this.props.hideModal(e, obj);
      }
    }
  }, {
    key: '_setFocusToFirstItemInModal',
    value: function _setFocusToFirstItemInModal(obj) {
      // get list of all children elements in given object
      var o = obj.find('*');

      // set the focus to the first keyboard focusable item
      // TODO: fix lint error
      /* eslint-disable no-undef */
      o.filter(focusableElementsString).filter(':visible').first().focus();
      /* eslint-enable no-undef */
    }
  }, {
    key: '_setInitialFocusModal',
    value: function _setInitialFocusModal(obj) {
      // get list of all children elements in given object
      var o = obj.find('*');

      // set focus to first focusable item
      // TODO: fix lint error
      /* eslint-disable no-unused-vars, no-undef */
      var focusableItems = o.filter(focusableElementsString).filter(':visible').first().focus();
      /* eslint-enable no-unused-vars, no-undef */
    }

    /* _trapTabKey(obj, e) {
       // if tab or shift-tab pressed
      if (e.which == 9) {
           // get list of all children elements in given object
          // var o = obj.find('*');
           // get list of focusable items
          var focusableItems;
          // focusableItems = o.filter(focusableElementsString).filter(':visible')
          focusableItems = obj.querySelectorAll(focusableElementsString).filter((el)=>{
            return el.offsetParent !== null;
          });
           // get currently focused item
          var focusedItem;
          focusedItem = jQuery(':focus');
          //focusedItem = document.querySelector(":focus");
           // get the number of focusable items
          var numberOfFocusableItems;
          numberOfFocusableItems = focusableItems.length
           // get the index of the currently focused item
          var focusedItemIndex;
          focusedItemIndex = focusableItems.index(focusedItem);
           if (e.shiftKey) {
              //back tab
              // if focused on first item and user preses back-tab, go to the last focusable item
              if (focusedItemIndex == 0) {
                  focusableItems.get(numberOfFocusableItems - 1).focus();
                  e.preventDefault();
              }
           } else {
              //forward tab
              // if focused on the last item and user preses tab, go to the first focusable item
              if (focusedItemIndex == numberOfFocusableItems - 1) {
                  focusableItems.get(0).focus();
                  e.preventDefault();
              }
          }
      }
     },
     _trapEscapeKey(obj, e) {
       // if escape pressed
      if (e.which == 27) {
           // get list of all children elements in given object
          var o = obj.find('*');
           // get list of focusable items
          var cancelElement;
          cancelElement = o.filter("#cancel")
           // close the modal window
          cancelElement.click();
          e.preventDefault();
      }
     }, */

  }, {
    key: 'render',
    value: function render() {
      // TODO: fix these lint errors
      /* eslint-disable no-unused-vars */

      // jQuery formatted selector to search for focusable items
      var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
      // store the item that has focus before opening the modal window
      var focusedElementBeforeModal = void 0;

      /* eslint-enable no-unused-vars */

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { id: 'modal-container', className: 'vst-modal', onKeyDown: this._trapTabKey, 'aria-labelledby': 'modalTitle', 'aria-describedby': 'modalDescription', role: 'dialog' },
          _react2.default.createElement(
            'div',
            { style: { width: this.state.modalWidth, height: this.state.modalHeight }, className: 'modal-document', role: 'document' },
            _react2.default.createElement(
              'div',
              { id: 'modal-document-inner' },
              _react2.default.createElement(
                'h1',
                { id: 'modal-title' },
                this.props.title
              ),
              this.props.children,
              _react2.default.createElement(
                'button',
                { onClick: this._hideModal, className: 'modal-close-button' },
                svgXIcon(),
                _react2.default.createElement(
                  'span',
                  { className: 'offScreen' },
                  i18n.t('base.close')
                )
              )
            )
          )
        ),
        _react2.default.createElement('div', { onClick: this._hideModal, 'aria-hidden': true, className: 'vst-modalOverlay', tabIndex: '-1' })
      );
    }
  }]);

  return VstModal;
}(_react.Component);

VstModal.propTypes = {
  hideModal: _propTypes2.default.func,
  title: _propTypes2.default.string,
  children: _propTypes2.default.node
};

exports.default = VstModal;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstModal.js
 **/